import { __decorate } from "tslib";
import axios from 'axios';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let SearchResults = class SearchResults extends VuexModule {
    constructor() {
        super(...arguments);
        this.searchResults = [];
    }
    async fetchSearchResults(searchText) {
        searchText = `${searchText}*`;
        let results;
        try {
            results = await axios.get(`${process.env.VUE_APP_sw5eapiurl}/api/search`, { params: { searchText } });
            await this.dispatch('dataVersions/setInternet', null, { root: true });
        }
        catch (e) {
            console.error('Failed to get search results');
            await this.dispatch('dataVersions/setNoInternet', null, { root: true });
            throw e;
        }
        return { searchResults: results.data };
    }
};
__decorate([
    MutationAction({ mutate: ['searchResults'] })
], SearchResults.prototype, "fetchSearchResults", null);
SearchResults = __decorate([
    Module({ namespaced: true, name: 'searchResults' })
], SearchResults);
export default SearchResults;
